





































import moment from 'moment'

export default
  props:
    value:
      type: String
      default: ''
    switching:
      type: Boolean
      default: true
    halfWidth:
      type: Boolean
      default: false
    events:
      type: Array
      dafalt: []
    dailyAmount:
      type: Number
      default: 0

  data: () ->
    month: ''

  computed: {
    title: () ->
      return moment(@month).format('yyyy年 M月')
  }
  created: () ->
    @month = @value

  methods: {
    getEventColor: (event) ->
      return event.color
    showEvent: (event) ->
      #イベントの内容が見れる
      # console.log event
    viewDay: (date) ->
      #クリックした日がわかる
      @$emit('click', date, @accept(date.date))
    getEvents: () ->
      #カレンダーが表示、切り替えると呼ばれる
      @$emit('change', @month)
    accept: (date) ->
      for row, index in @events
        if row.start == date && row.name == '供給不可日'
          return false
      return true
    returnDay: (timestamp) ->
      if moment(@month).isSame(new Date(timestamp.date), 'month')
        return new Date(timestamp.date).getDate()
      return ''

  }
